import React, { useState, useEffect, useContext } from "react";
import momentZone from "moment-timezone";
import { Clock } from "../LeadsDashboardComponents/StatCardIcons";
import { GlobalContext } from "../../context/Context";


const phpToMoment = (phpFormat) => {
    if (!phpFormat) return "DD MMM YYYY, hh:mm A";

    return phpFormat
        .replace(/d/g, "DD")
        .replace(/j/g, "D")
        .replace(/M/g, "MMM")
        .replace(/F/g, "MMMM")
        .replace(/Y/g, "YYYY")
        .replace(/y/g, "YY")
        .replace(/h/g, "hh")
        .replace(/H/g, "HH")
        .replace(/i/g, "mm")
        .replace(/s/g, "ss")
        .replace(/a/g, "a")
        .replace(/A/g, "A");
};

const DateTime = ({
    toZone = "Asia/Karachi",
    intervalTime = 5000,
    label = "Current Time",
    className = "",
    showIcon = true,
}) => {
    const [currentTime, setCurrentTime] = useState("");
    const { state } = useContext(GlobalContext);

    const format =
        phpToMoment(state?.user?.date_time_format) || "DD MMM YYYY, hh:mm A";

    const getCurrentTime = () => {
        const fromZone = momentZone.tz.guess();
        const newNow = momentZone.tz(new Date(), fromZone);
        const converted = newNow.clone().tz(toZone);
        const formattedTime = converted.format(format);
        setCurrentTime(formattedTime);
    };

    useEffect(() => {
        getCurrentTime();
        const interval = setInterval(getCurrentTime, intervalTime);
        return () => clearInterval(interval);
    }, [toZone, format, intervalTime]);

    return (
        <div
            className={`flex items-center gap-5 p-3 rounded-[10px] border border-[rgba(255,255,255,1)] bg-[rgba(255,255,255,0.60)] ${className}`}
        >
            <div className="flex flex-col gap-[5px]">
                <p className="text-sm leading-none text-[rgba(14,18,27,0.60)]">
                    {label}
                </p>
                <div className="text-xl leading-none font-bold flex items-center gap-1">
                    {currentTime}
                </div>
            </div>
            {showIcon && <Clock />}
        </div>
    );
};

export default DateTime;